import { render, staticRenderFns } from "./Dispose.vue?vue&type=template&id=17c0bfa0&scoped=true&"
import script from "./Dispose.vue?vue&type=script&lang=js&"
export * from "./Dispose.vue?vue&type=script&lang=js&"
import style0 from "./Dispose.vue?vue&type=style&index=0&id=17c0bfa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c0bfa0",
  null
  
)

export default component.exports